import axios from 'axios'

axios.defaults.timeout = 60000 // 请求超时
// 增加默认请求路径前缀
axios.defaults.baseURL = '/recurit' // 增加请求默认路径前缀

if (location.href.includes('localhost:8081') || (location.href.includes('192.168.3.15:8081'))) {
  // 前端调试
  axios.defaults.baseURL = '/api/recurit' // 增加请求默认路径前缀
}

export default {
  /**
   * get 请求
   * @param url 接口路由
   * @param params
   * @param headers
   * @returns {AxiosPromise<any>}
   */
  get (url, params, headers) {
    let options = {}
    if (params) {
      options.params = params
    }
    if (headers) {
      options.headers = headers
    }
    return axios.get(url, options)
  },

  /**
   * post 请求
   *
   * @param url 接口路由
   * @param headers
   * @param data
   * @returns {AxiosPromise<any>}
   */
  post (url, data, headers) {
    let options = {}

    if (headers) {
      options.headers = headers
    }
    return axios.post(url, data, options)
  },

  /**
   * put 请求
   *
   * @param url 接口路由
   * @param headers
   * @param data
   * @returns {AxiosPromise<any>}
   */
  put (url, data, headers) {
    let options = {}

    if (headers) {
      options.headers = headers
    }
    return axios.put(url, data, options)
  },

  /**
   * delete 请求
   *
   * @param url 接口路由
   * @param headers
   * @param data
   * @returns {AxiosPromise<any>}
   */
  delete (url, params, data, headers) {
    let options = {}

    if (params) {
      options.params = params
    }
    if (headers) {
      options.headers = headers
    }
    if (data) {
      return axios.delete(url, data)
    }
    return axios.delete(url, options)
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js